import { Spinner, WizardStep } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { settingsInitialData } from 'modules/marketplace/components/utils/settingsInitialData'
import { useGetMarketplaceCompanyInstallations } from 'modules/marketplace/hooks/integrations/companyInstallations/useGetMarketplaceCompanyInstallations'
import { useGetMarketplaceSettings } from 'modules/marketplace/hooks/integrations/formQuestions/useGetMarketplaceSettings'
import { WizardData } from 'modules/marketplace/lib/types'

import { GenericForm } from './GenericForm'
import SettingsWizard from './Wizard'
import { useSettingsSteps } from './useSettingsSteps'

type SetupProps = {
  integration: ItemIntegrationFragment
}

const InternalIntegrations = ({ integration }: SetupProps) => {
  const { company } = useCurrentSession()

  const { data: companyInstallationsData, loading: loadingCompanyInstallations } =
    useGetMarketplaceCompanyInstallations(
      {
        // FIXME: We should arrange the components to call this hook only when there is an id
        integrationIds: [integration.id || 0],
      },
      !integration.id
    )

  const { data: settingsData, loading: loadingSettings } = useGetMarketplaceSettings(
    {
      integrationId: Number(integration.id),
      companyId: company.id,
    },
    !integration.id
  )

  const steps: WizardStep<WizardData>[] = useSettingsSteps(integration ? integration.datoId : '')
  const initialData = settingsInitialData(companyInstallationsData.at(0)?.formData || undefined)

  if (loadingCompanyInstallations || loadingSettings) return <Spinner />
  if (!integration.id) return <NotFound />

  return steps.length > 0 ? (
    <SettingsWizard integration={integration} steps={steps} initialData={initialData} />
  ) : (
    settingsData && <GenericForm settings={settingsData} integration={integration} />
  )
}

export default InternalIntegrations
